import React, { useRef, useState, useLayoutEffect } from 'react'
import { data } from '../data/content'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import AnimatedPage from '../components/AnimatedPage'
import { calcInteractions } from '../helpers/functions'
import bgImage from '../assets/General/General_Clean.jpg'
import bgImage2 from '../assets/Start/Start_Still.jpg'

const fadeIn = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 1,
      delay: 0.5,
    },
  },
  exit: {
    opacity: 0,
  },
}

export default function Home() {
  const thisRef = useRef()
  const timeoutRef = useRef()
  const [interactionsWidth, setInteractionsWidth] = useState('0px')
  const [interactionsHeight, setInteractionsHeight] = useState('0px')
  const navigate = useNavigate()

  const { categories } = data

  useLayoutEffect(() => {
    const sixteenNineAspect = 16 / 9
    const viewportHeight = window.innerHeight
    const viewportWidth = window.innerWidth
    const widthIfConstarainedByHeight = viewportHeight * sixteenNineAspect
    const heightIfConstarainedByWidth = viewportWidth / sixteenNineAspect

    // calculate interactions size on load
    if (widthIfConstarainedByHeight <= viewportWidth) {
      setInteractionsWidth(widthIfConstarainedByHeight + 'px')
      setInteractionsHeight(viewportHeight + 'px')
    } else {
      setInteractionsWidth(viewportWidth + 'px')
      setInteractionsHeight(heightIfConstarainedByWidth + 'px')
    }

    const resizeFunctions = () => {
      calcInteractions()
    }

    window.addEventListener('resize', resizeFunctions)

    const navTo = (e) => {
      const target = e.target.classList.contains('nav-btn')
        ? e.target
        : e.target.parentElement
      const isPlayAll = e.target.classList.contains('play-all')
      const navToRoute = target.dataset.route

      timeoutRef.current = setTimeout(() => {
        navigate(navToRoute, { state: { transition: 0, isPlayAll } })
      }, 500)
    }

    const navBtns = thisRef.current.querySelectorAll('.nav-btn')

    navBtns.forEach((navBtn) => {
      navBtn.addEventListener('click', navTo)
    })

    // Unmount -> cleanup
    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [navigate])

  return (
    <AnimatedPage>
      <main
        className='d-flex flex-grow-1 flex-column justify-content-center align-items-center bg-black overflow-hidden'
        ref={thisRef}
      >
        <div className='ratio ratio-16x9 mh-100vh'>
          <img
            src={bgImage}
            style={{ objectFit: 'contain' }}
            alt='background'
          />
          <motion.img
            variants={fadeIn}
            initial='initial'
            animate='animate'
            exit='exit'
            src={bgImage2}
            style={{ objectFit: 'contain' }}
            alt='background'
          />
          <div
            className='interactions overflow-hidden'
            style={{ width: interactionsWidth, height: interactionsHeight }}
          >
            {categories.map(({ categorySlug, homePageButtonStyles }, index) => {
              return homePageButtonStyles ? (
                <div
                  key={index}
                  data-route={`/${categorySlug}/0`}
                  className='position-absolute nav-btn'
                  style={{ ...homePageButtonStyles }}
                />
              ) : null
            })}
            <div
              data-route={`/${categories[0].categorySlug}/0`}
              className='position-absolute nav-btn play-all'
              style={{
                width: '13%',
                height: '35.9%',
                top: '46%',
                left: '6.5%',
              }}
            />
          </div>
        </div>
      </main>
    </AnimatedPage>
  )
}
